export const process_content = [
  {
    value: "Nộp đơn",
    label: "Nộp đơn",
  },
  {
    value: "Yêu cầu bổ sung",
    label: "Yêu cầu bổ sung",
  },
  {
    value: "Bổ sung ủy quyền gốc",
    label: "Bổ sung ủy quyền gốc",
  },
  {
    value: "Trả lời bổ sung",
    label: "Trả lời bổ sung",
  },
  {
    value: "Bị phản đối",
    label: "Bị phản đối",
  },
  {
    value: "Trả lời phản đối",
    label: "Trả lời phản đối",
  },
  {
    value: "Chấp nhận hợp lệ",
    label: "Chấp nhận hợp lệ",
  },
  {
    value: "Thông báo nội dung",
    label: "Thông báo nội dung",
  },
  {
    value: "Trả lời thông báo nội dung",
    label: "Trả lời thông báo nội dung",
  },
  {
    value: "Thông báo cấp bằng",
    label: "Thông báo cấp bằng",
  },
  {
    value: "Nộp phí cấp bằng",
    label: "Nộp phí cấp bằng",
  },
  {
    value: "Cấp bằng",
    label: "Cấp bằng",
  },
  {
    value: "Từ chối hợp lệ",
    label: "Từ chối hợp lệ",
  },
  {
    value: "Từ chối cấp bằng",
    label: "Từ chối cấp bằng",
  },
  {
    value: "Chuyển giao đơn",
    label: "Chuyển giao đơn",
  },
  {
    value: "Rút đơn",
    label: "Rút đơn",
  },
  {
    value: "Đề nghị hủy bỏ/chấm dứt hiệu lực",
    label: "Đề nghị hủy bỏ/chấm dứt hiệu lực",
  },
  {
    value: "Trả lời đề nghị hủy bỏ/chấm dứt hiệu lực",
    label: "Trả lời đề nghị hủy bỏ/chấm dứt hiệu lực",
  },
  {
    value: "Hủy bỏ/chấm dứt hiệu lực",
    label: "Hủy bỏ/chấm dứt hiệu lực",
  },
];
